import React from 'react'
import PropTypes from 'prop-types'
import cssModules from 'react-css-modules'
import { getI18n } from 'client/i18n'
import {
  detailDaysFromToday,
  formatTime,
} from 'shared/helpers/datetime_helpers'
import { HeadingText } from '@paypalcorp/pp-react'

import styles from './count_down.less'

export const I18N_CONTEXT = 'components/common/count_down'
const i18n = getI18n(I18N_CONTEXT)

class CountDown extends React.Component {
  static propTypes = {
    datetime: PropTypes.string,
    showSeconds: PropTypes.boolean,
    format: PropTypes.Array,
  }

  intervalId = null
  defaultFormat = ['days']
  updateSeconds = false
  separator = ':'

  constructor(props) {
    super(props)
    this.state = detailDaysFromToday(this.props.datetime)
    this.showDetail = this.state.days < 2
    // only update seconds if we have default format or in custom format
    this.updateSeconds =
      !this.props.format || this.props.format.indexOf('seconds') > -1
  }

  updateCountDown() {
    const countDown = detailDaysFromToday(this.props.datetime)
    this.setState(countDown)
  }

  // function to start the countdown and update the state every minute
  startCountDown(interval = 1) {
    this.updateCountDown()
    this.intervalId = setInterval(() => this.updateCountDown(), interval * 1000)
  }

  getTimeFormat(cdItem) {
    let time = this.state[cdItem] || 0
    if (cdItem === 'hours') {
      time += 24 * this.state.days
    }
    let timeFormat = `${time}${formatTime[cdItem]}`
    return time < 10 ? `0${timeFormat}` : `${timeFormat}`
  }

  showRemainingInDays() {
    return this.defaultFormat.map((cdItem, index) => {
      return (
        <div styleName="unit_container" key={index}>
          <div>
            <HeadingText size="lg" styleName="unit_value">
              {`${this.state[cdItem]} `}
              {i18n('days')}
            </HeadingText>
          </div>
        </div>
      )
    })
  }

  showRemainingInDetail() {
    return (this.props.format || this.defaultFormat).map((cdItem, index) => {
      return (
        <div styleName="unit_container" key={index}>
          {index > 0 ? (
            <HeadingText size="lg" styleName="unit_separator">
              {this.separator}
            </HeadingText>
          ) : null}

          <div>
            <HeadingText size="lg" styleName="unit_value">
              {`${this.getTimeFormat(cdItem)}`}
            </HeadingText>
          </div>
        </div>
      )
    })
  }

  renderComponents() {
    return this.showDetail
      ? this.showRemainingInDetail()
      : this.showRemainingInDays()
  }

  clearCountDowns() {
    if (this.intervalId) {
      clearInterval(this.intervalId)
    }
  }

  componentWillMount() {
    // initiate the countdown to run every min after roll over seconds.
    if (this.updateSeconds) {
      return this.startCountDown()
    }

    setTimeout(() => this.startCountDown(60), this.state.seconds * 1000)
  }

  componentWillUnmount() {
    this.clearCountDowns()
  }

  render() {
    return <div styleName="count_down_container">{this.renderComponents()}</div>
  }
}

export default cssModules(CountDown, styles, {
  allowMultiple: true,
})
